export const isIOSWebView = /iOSTourApp\//i.test(navigator.userAgent);
